import { render, staticRenderFns } from "./HeaderBalanceChannel.vue?vue&type=template&id=5c359f1a&"
import script from "./HeaderBalanceChannel.vue?vue&type=script&lang=js&"
export * from "./HeaderBalanceChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports